import { CustomExamCenters } from './constants';
import laposteLogo from '../../../images/logos/logo-la-poste-vector.svg';
import codengoLogo from '../../../images/logos/logo-codengo-vector.svg';
import dekraLogo from '../../../images/logos/logo-dekra-one-line.svg';
import sgsLogo from '../../../images/logos/sgs.svg';
import laposteBackground from '../../../images/examCentersReviewHeaders/background-image-laposte.webp';
import laposteBackground2x from '../../../images/examCentersReviewHeaders/background-image-laposte@2x.webp';
import codengoBackground from '../../../images/examCentersReviewHeaders/background-image-codengo.webp';
import codengoBackground2x from '../../../images/examCentersReviewHeaders/background-image-codengo@2x.webp';
import dekraBackground from '../../../images/examCentersReviewHeaders/background-image-dekra.webp';
import dekraBackground2x from '../../../images/examCentersReviewHeaders/background-image-dekra@2x.webp';
import sgsBackground from '../../../images/examCentersReviewHeaders/background-image-sgs.jpg';
import sgsBackground2x from '../../../images/examCentersReviewHeaders/background-image-sgs@2x.jpg';
import {
  MAIN_BLUE, PALE_GREY, TEXT_COLOR, GRAY_CHATEAU,
} from '../../../theme';

export const commonTheme = {
  drivingSchoolTypeColor: PALE_GREY,
  drivingSchoolSelectedTypeFontColor: GRAY_CHATEAU,
  buttonColor: MAIN_BLUE,
  buttonTextColor: '#fff',
};
export const customThemes = {
  [CustomExamCenters.LA_POSTE]: {
    background: {
      color: '#ffcb05',
      image: laposteBackground,
      image2x: laposteBackground2x,
      repeat: 'no-repeat',
      position: 'bottom right',
      positionMobile: 'bottom 0 right -125px',
      size: 'auto 100%',
    },
    imagePath: laposteLogo,
    logoWidth: '54px',
    logoHeight: '42px',
    title: {
      color: '#003da5',
      fontSize: '48px',
      fontSizeMobile: '24px',
      lineHeight: '1.17',
      letterSpacing: '0.1px',
      textAlign: 'left',
      top: '56px',
      topMobile: '94px',
      left: '64px',
      leftMobile: '24px',
    },
    drivingSchoolTypeColor: '#ffcb05',
    drivingSchoolSelectedTypeFontColor: TEXT_COLOR,
    buttonColor: '#ffcb05',
    buttonTextColor: TEXT_COLOR,
  },
  [CustomExamCenters.CODENGO]: {
    background: {
      color: '#24ace0',
      image: codengoBackground,
      image2x: codengoBackground2x,
      repeat: 'no-repeat',
      position: 'top left',
      positionMobile: 'top left',
      size: 'cover',
    },
    imagePath: codengoLogo,
    logoWidth: '50px',
    logoHeight: '50px',
    title: {
      color: '#fff',
      fontSize: '48px',
      fontSizeMobile: '24px',
      lineHeight: '1.17',
      letterSpacing: '0.1px',
      textAlign: 'left',
      top: '0',
      topMobile: '0',
      left: '0',
      leftMobile: '0',
    },
    drivingSchoolTypeColor: '#ddda19',
    drivingSchoolSelectedTypeFontColor: '#6f6e61',
    buttonColor: '#ddda19',
    buttonTextColor: '#6f6e61',
  },
  [CustomExamCenters.DEKRA]: {
    background: {
      color: '#f2f2f2',
      image: dekraBackground,
      image2x: dekraBackground2x,
      repeat: 'no-repeat',
      position: 'center',
      positionMobile: 'center',
      size: 'cover',
    },
    imagePath: dekraLogo,
    logoWidth: '72px',
    logoHeight: '20px',
    logoMarginTop: '12px',
    title: {
      color: '#007934',
      fontSize: '32px',
      fontSizeMobile: '24px',
      lineHeight: 'normal',
      letterSpacing: '0.2px',
      textAlign: 'right',
      top: '64px',
      topMobile: '64px',
      left: 'auto',
      leftMobile: 'auto',
      right: '48px',
      rightMobile: '16px',
    },
    drivingSchoolTypeColor: '#007934',
    drivingSchoolSelectedTypeFontColor: '#fff',
    buttonColor: '#007934',
    buttonTextColor: '#fff',
  },
  [CustomExamCenters.SGS]: {
    background: {
      color: '#efefef',
      image: sgsBackground,
      image2x: sgsBackground2x,
      repeat: 'no-repeat',
      position: 'bottom left',
      positionMobile: 'bottom left',
      size: 'contain',
    },
    imagePath: sgsLogo,
    logoWidth: '60px',
    logoHeight: '36px',
    logoMarginTop: '7px',
    title: {
      color: TEXT_COLOR,
      fontSize: '32px',
      fontSizeMobile: '24px',
      lineHeight: 'normal',
      letterSpacing: '0.2px',
      textAlign: 'center',
      top: '84px',
      topMobile: '72px',
      left: '50%',
      leftMobile: '50%',
      transform: 'translateX(-50%)',
    },
    drivingSchoolTypeColor: '#fd4f08',
    drivingSchoolSelectedTypeFontColor: '#fff',
    buttonColor: '#fd4f08',
    buttonTextColor: '#fff',
  },
};
